import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'brt-prompt-text',
  templateUrl: './prompt-text.component.html',
  styleUrls: ['./prompt-text.component.scss']
})
export class PromptTextComponent {
  @ViewChild('inputWrapper') set setInputWrapper(val: ElementRef<HTMLElement>) {
    if(val) {
      // console.log(val.nativeElement.querySelector("input"));
      val.nativeElement.querySelector("input")?.focus();
    }
  }

  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  inProcess = false;
  @Input('label') label = "";
  @Input('currentValue') currentValue = "";
  @Input('confirmCallback') confirmCallback?: (text: string) => void;
  @Input('cancelCallback') cancelCallback?: () => void;
  @Input('confirmText') confirmText = "";
  @Input('minLength') minLength = 0;

  confirm() {
    if(!this.inProcess) {
      this.inProcess = true;

      if(this.confirmCallback) {
        this.confirmCallback(this.currentValue);
        this.onClosed.emit(true);
      }
    }
  }

  onCancelClicked() {
    if(this.cancelCallback) {
      this.cancelCallback()
    }
    this.onClosed.emit(true);
  }
}
